import {
  FUND_INVESTMENTS_COMPANIES_TITLE,
  FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR,
  FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE,
  FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE_SINGULAR,
} from 'pages/FundInvestments/common/constants';
import { GetMeasurementDateEntityNameParams, GetMeasurementDateInfoParams } from './CompaniesTable.types';

export const MOST_RECENT_DATE = 'Most Recent Date';

export const getMeasurementDateEntityName = (params: GetMeasurementDateEntityNameParams): string => {
  const { areFundInvestmentsEnabled, companyCount } = params;

  if (companyCount > 1) {
    return areFundInvestmentsEnabled
      ? FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE
      : FUND_INVESTMENTS_COMPANIES_TITLE;
  }

  return areFundInvestmentsEnabled
    ? FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE_SINGULAR
    : FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR;
};

export const getMeasurementDateInfo = (params: GetMeasurementDateInfoParams): string => {
  const { areFundInvestmentsEnabled = false, companyCount, fundCount } = params;

  return `Creating a new measurement date for ${fundCount} ${
    fundCount > 1 ? 'Funds' : 'Fund'
  } and ${companyCount} ${getMeasurementDateEntityName({
    areFundInvestmentsEnabled,
    companyCount,
  })}. The new Measurement date will copy the valuation (as a draft), related cap tables, related financials, notes, and all referenced documents. The market data will be updated and set to the new measurement data, or customize the rollover using the custom options below.`;
};

export const getMeasurementDateMismatchMessage = (areFundInvestmentsEnabled: boolean): string =>
  `One or more ${getMeasurementDateEntityName({
    areFundInvestmentsEnabled,
    companyCount: Number.POSITIVE_INFINITY,
  })} did not have a source date matching the default source date`;
